<app-shell-admin-warning-banner></app-shell-admin-warning-banner>
<ng-container *ngIf="viewModel$ | async as viewModel">
	<dx-data-grid height="calc(100vh - 320px)"
		[dataSource]="viewModel.dataSource"
		[showBorders]="true"
		(onRowRemoving)="rowRemoving($event)"
	>
		<dxo-sorting mode="multiple"></dxo-sorting>
		<dxo-filter-row [visible]="true"></dxo-filter-row>
		<dxo-editing [allowAdding]="true" [allowUpdating]="true" [allowDeleting]="true"></dxo-editing>
		<dxo-search-panel [visible]="true"></dxo-search-panel>

		<dxi-column
			dataField="creationDate"
			caption="Creation date"
			dataType="datetime"
			format="yyyy-MM-dd HH:mm:ss"
			[width]="120"
		>
		</dxi-column>
		<dxi-column
			dataField="name"
			caption="Company name"
		>
		</dxi-column>
		<dxi-column
			dataField="fullIdentifier"
			caption="Company identifier"
		>
		</dxi-column>
		<dxi-column
			dataField="companyType"
			caption="Company type"
			cellTemplate="companyTypeTemplate"
			alignment="left"
			[width]="100"
		>
		</dxi-column>
		<dxi-column
			dataField="isMainCompany"
			caption="Is main company"
			dataType="boolean"
		>
		</dxi-column>
		<dxi-column
			dataField="parentCompanyId"
			caption="Parent company"
		>
			<dxo-lookup
				[dataSource]="viewModel.parentCompanyDatasource"
				valueExpr="id"
				displayExpr="name"
				[allowClearing]="true"
			>
			</dxo-lookup>
		</dxi-column>
		<dxi-column
			dataField="timezoneString"
			caption="Company timezone"
			[width]="145"
		>
		</dxi-column>

		<div *dxTemplate="let data of 'companyTypeTemplate'">
			{{getCompanyEnumValue(data.data.companyType) }}
		</div>
	</dx-data-grid>
</ng-container>
